import { Map as ImmutableMap } from 'immutable';
import RequestStatusTypes from '../constants/RequestStatusTypes';
const initialState = ImmutableMap();
export default function (state = initialState, action) {
  if (typeof action.type === 'string' && action.type.length) {
    const split = action.type.split('_');
    const requestSuffix = split[split.length - 1];
    const requestType = split.slice(0, split.length - 1).join('_');
    switch (requestSuffix) {
      case 'REQUEST':
        return state.set(requestType, RequestStatusTypes.PENDING);
      case 'SUCCESS':
        return state.set(requestType, RequestStatusTypes.SUCCEEDED);
      case 'FAILURE':
        return state.set(requestType, RequestStatusTypes.FAILED);
      default:
        return state;
    }
  }
  return state;
}